import classNames from 'classnames';

import { SwimlaneItem } from '@rikstv/play-common/src/forces/assetDetails/assetDetails.types';
import { H3 } from '@rikstv/shared-components';

import { getLinkTo } from '../swimlane.utils';

import { ItemWrapper } from './ItemWrapper';

import styles from './MenuTextItem.module.css';

export const MenuTextItem = ({ asset, onClick }: { asset: SwimlaneItem; onClick: () => void }) => {
  return (
    <div className={classNames(styles.wrapper, 'with-keyboard-focus-within')}>
      <ItemWrapper className={styles.menuTextItem} linkTo={getLinkTo(asset)} onClick={onClick}>
        <H3 className={styles.menuItemTitle} lookLike={'title-4'}>
          {asset.title}
        </H3>
      </ItemWrapper>
    </div>
  );
};

export const PageFilterMenuItem = ({
  title,
  link,
  onClick,
  selected,
}: {
  title: string;
  link: string;
  onClick: () => void;
  selected: boolean;
}) => {
  return (
    <div className={classNames(styles.wrapper, 'with-keyboard-focus-within')}>
      <ItemWrapper
        className={classNames(styles.menuTextItem, { [styles.selected]: selected })}
        ariaCurrent={selected ? 'page' : undefined}
        linkTo={link}
        onClick={onClick}>
        <H3 className={styles.menuItemTitle} lookLike={'title-4'}>
          {title}
        </H3>
      </ItemWrapper>
    </div>
  );
};
